"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const smap_1 = require("./smap");
const buildings_1 = __importDefault(require("./content/buildings"));
const byproducts_1 = __importDefault(require("./content/byproducts"));
const displayStrings_1 = __importDefault(require("./content/displayStrings"));
const hideOnBuy_1 = __importDefault(require("./content/hideOnBuy"));
const recipeValues_1 = __importDefault(require("./content/recipeValues"));
const storage_1 = __importDefault(require("./content/storage"));
const layout_1 = __importDefault(require("./content/layout"));
const unlockedWith_1 = __importDefault(require("./content/unlockedWith"));
const maxCraft_1 = __importDefault(require("./content/maxCraft"));
const bigmath_1 = require("./bigmath");
const byproductRatesPerSecond = {};
const recipesConsumingThis = {};
const allItemNames = (0, smap_1.keys)(recipeValues_1.default.recipes).sort();
allItemNames.shift();
const unlocks = {};
(0, smap_1.keys)(unlockedWith_1.default.unlockedWith).forEach((l) => {
    unlockedWith_1.default.unlockedWith[l]?.forEach((k) => {
        unlocks[k] ??= [];
        unlocks[k]?.push(l);
    });
});
function fillWithDefault(partial, defaultItem) {
    const t = {};
    allItemNames.forEach(name => {
        if (partial[name] === undefined) {
            t[name] = defaultItem();
        }
        else {
            t[name] = partial[name];
        }
    });
    return t;
}
const ex = {
    sections: layout_1.default.sections,
    assemblerSpeeds: fillWithDefault(buildings_1.default.assemblerSpeeds, () => 0),
    byHandVerbs: fillWithDefault(displayStrings_1.default.byHandVerbs, () => "craft"),
    displayNames: (item) => item === "by-hand"
        ? "By Hand"
        : displayStrings_1.default.displayNames[item] ?? item,
    hideOnBuy: (item) => hideOnBuy_1.default.hideOnBuy.includes(item),
    itemsCanBeStoreIn: fillWithDefault(storage_1.default.itemsCanBeStoreIn, () => []),
    recipeScaleFactor: fillWithDefault(recipeValues_1.default.recipeScaleFactor, () => 1.0),
    recipes: (0, smap_1.mapValues)(recipeValues_1.default.recipes, recipe => (0, smap_1.mapValues)(recipe, v => (0, bigmath_1.NumToBig)(v))),
    requiredBuildings: (item) => buildings_1.default.requiredBuildings[item] ?? ["by-hand"],
    timePerRecipe: recipeValues_1.default.timePerRecipe,
    sideProducts: fillWithDefault(byproducts_1.default.byproducts, () => []),
    hideByproducts: fillWithDefault(byproducts_1.default.hideByproducts, () => false),
    storageSizes: fillWithDefault(storage_1.default.storageSizes, () => 0n),
    unlockedWith: fillWithDefault(unlockedWith_1.default.unlockedWith, () => []),
    unlocks: fillWithDefault(unlocks, () => []),
    hideUnlocks: fillWithDefault(unlockedWith_1.default.hideUnlocks, () => false),
    allItemNames: allItemNames,
    allAssemblers: (0, smap_1.keys)(buildings_1.default.assemblerSpeeds),
    /**
     *
     * @param item the item made as a byproduct
     * @returns the recipes that make this item as a byproduct
     */
    makesAsASideProduct: (item) => makesAsASideProduct[item],
    maxCraftAtATime: (item, state) => {
        const max = maxCraft_1.default.maxCraftAtATime[item] ?? maxCraft_1.default.ABSOLUTE_MAX_CRAFT;
        if (typeof max === 'bigint') {
            return max;
        }
        return max(ex, state);
    },
    flavorText: displayStrings_1.default.flavorText,
    byproductRatesPerSecond: fillWithDefault(byproductRatesPerSecond, () => ({})),
    recipesConsumingThis: fillWithDefault(recipesConsumingThis, () => []),
    MIN_STORAGE: (0, bigmath_1.NumToBig)(storage_1.default.MIN_STORAGE),
    buildingPowerRequirementsPerSecond: fillWithDefault((0, smap_1.mapValues)(buildings_1.default.buildingPowerRequirementsPerSecond, recipe => (0, smap_1.mapValues)(recipe, v => (0, bigmath_1.NumToBig)(v))), () => ({})),
    buildingBoosts: buildings_1.default.buildingBoosts,
    buildingBoostTiers: fillWithDefault(buildings_1.default.buildingBoostTiers, () => buildings_1.default.defaultBuildingBoostTiers),
    buildingPowerDisplayWord: buildings_1.default.buildingPowerDisplayWord,
    calculateBoost: (recipe, state) => {
        const boostingItem = ex.buildingBoosts[recipe];
        if (!boostingItem)
            return 1;
        const amount = (0, bigmath_1.bigToNum)(state.amountThatWeHave[boostingItem]);
        if (!amount)
            return 1;
        const boost = ex.buildingBoostTiers[boostingItem][amount];
        if (!boost)
            return 2 ** amount;
        return boost;
    },
    calculateRecipeScale: (item, amount) => {
        if (!item || !amount)
            return (0, bigmath_1.NumToBig)(1);
        const scale = ex.recipeScaleFactor[item];
        if (scale == 1)
            return (0, bigmath_1.NumToBig)(1);
        return (0, bigmath_1.bigCeil)((0, bigmath_1.bigpow)(scale, amount));
    },
    displayNewBadge: fillWithDefault(unlockedWith_1.default.displayNewBadge, () => true),
};
(0, smap_1.keys)(recipeValues_1.default.recipes).forEach((item) => {
    if (item.startsWith("research-")) {
        displayStrings_1.default.byHandVerbs[item] = "research";
        maxCraft_1.default.maxCraftAtATime[item] = (0, bigmath_1.NumToBig)(1);
    }
    // calculate side product rates per second (assuming constructor rate 1x)
    if (byproducts_1.default.byproducts[item]) {
        const rate = recipeValues_1.default.timePerRecipe[item];
        byproducts_1.default.byproducts[item]?.forEach((pool) => {
            const sum = lodash_1.default.sum((0, smap_1.values)(pool));
            (0, smap_1.keys)(pool).forEach((byproduct) => {
                byproductRatesPerSecond[byproduct] ??= {};
                byproductRatesPerSecond[byproduct][item] ??= 0;
                const chance = pool[byproduct] ?? 0;
                byproductRatesPerSecond[byproduct][item] +=
                    chance / sum / rate;
            });
        });
    }
    const recipe = recipeValues_1.default.recipes[item];
    (0, smap_1.mapPairs)(recipe, (count, ingredient) => {
        (ex.recipesConsumingThis[ingredient] ??= []).push(item);
    });
});
const makesAsASideProduct = (0, smap_1.mapValues)(recipeValues_1.default.recipes, (_, item) => {
    return (0, smap_1.keys)(byproducts_1.default.byproducts).filter((mainOutput) => mainOutput !== item &&
        ex.sideProducts[mainOutput].some((p) => p[item]));
});
exports.default = ex;
